<ng-container>
    <app-grid-client-side
        #departmentsGridComponent
        [headerCheckboxSelection]="true"
        (areRowsSelected)="handleSelectionChange($event)"
        (rowClicked)="rowClicked($event)"
        [hidden]="!gridPath"
        [tableData]="tableData[0]"
        [fixedButtons]="fixedButtons"
        (gridReadyEmitter)="onGridReady()"
        (filterChangedEmitter)="onFilterChangedEmitter($event)"
        [exportFormatterOptions]="exportFormatterOptions"
        (clickableAction)="actions($event)"
        feature="departments"
    ></app-grid-client-side>
</ng-container>